module.exports = __webpack_public_path__ + "img/portfolio-8.70fae66f.jpg";